/**
 * D8: Admin Settings
 * Source: src/portals/admin/pages/SettingsPage.tsx
 */

import { USE_BACKEND } from '../helpers'

const ADMIN_SETTINGS_KEY = 'meester-djay-admin-settings'

export async function getAdminSettings(): Promise<Record<
  string,
  unknown
> | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    const raw = localStorage.getItem(ADMIN_SETTINGS_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export async function saveAdminSettings(
  settings: Record<string, unknown>,
): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    localStorage.setItem(ADMIN_SETTINGS_KEY, JSON.stringify(settings))
  } catch {
    // silent
  }
}
